import React, { useState, useEffect } from 'react';
import { Modal, Button, Badge } from 'react-bootstrap';
import {
  FaWindowClose,
  FaSyncAlt,
  FaUserCircle,
  FaChevronDown,
  FaChevronUp,
  FaPhone,
  FaEnvelope,
  FaIdCard,
  FaCalendarAlt,
  FaBuilding,
  FaMapMarkerAlt,
  FaUserTie,
  FaUsers,
  FaBriefcase,
  FaVenusMars,
  FaRing,
  FaGlobe,
  FaHome,
  FaHashtag,
} from 'react-icons/fa';
import { Card, Row, Col } from 'react-bootstrap';
import * as api from '~/Services/Service';
import { toast } from 'react-toastify';
import Loading from '~/Components/Loading';
import './modalUnificar.css';
import { format } from '~/Utils/Helpers';
import { Nav, Form, InputGroup } from 'react-bootstrap';
import { FaSearch, FaExternalLinkAlt } from 'react-icons/fa';

const ModalUnificar = ({
  prospecto,
  mostrarModalUnificar,
  setMostrarModalUnificar,
  setProspecto,
  buscarProspecto,
}) => {
  const [prospectosSugestao, setProspectosSugestao] = useState([]);
  const [carregandoSugestao, setCarregandoSugestao] = useState(false);
  const [prospectoSelecionado, setProspectoSelecionado] = useState(null);
  const [unificandoProspecto, setUnificandoProspecto] = useState(false);
  const [expandedCards, setExpandedCards] = useState({});
  const [modoBusca, setModoBusca] = useState('sugestoes');
  const [termoBusca, setTermoBusca] = useState('');
  const [tipoBusca, setTipoBusca] = useState('telefone');
  const [buscandoManual, setBuscandoManual] = useState(false);

  useEffect(() => {
    if (prospecto) {
      buscarSugestoes();
    }
  }, []);

  const buscarSugestoes = async () => {
    try {
      setCarregandoSugestao(true);
      let response = await api.obterSugestaoProspectos(prospecto);
      if (response) {
        setProspectosSugestao(response);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setCarregandoSugestao(false);
    }
  };

  const validarBusca = () => {
    const termo = termoBusca.trim();

    if (!termo) {
      toast.warning('Digite um valor para buscar');
      return false;
    }

    if (tipoBusca === 'telefone') {
      const apenasNumeros = termo.replace(/\D/g, '');
      if (apenasNumeros.length < 8) {
        toast.warning('Digite um telefone válido (mínimo 8 dígitos)');
        return false;
      }
    }

    if (tipoBusca === 'email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(termo)) {
        toast.warning('Digite um email válido');
        return false;
      }
    }

    if (tipoBusca === 'prospecto') {
      const apenasNumeros = termo.replace(/\D/g, '');
      if (!apenasNumeros) {
        toast.warning('Digite um código de prospecto válido');
        return false;
      }
    }

    return true;
  };

  const buscarManual = async () => {
    if (!validarBusca()) {
      return;
    }

    try {
      setBuscandoManual(true);
      setProspectoSelecionado(null);
      const response = await api.buscarProspectoParaUnificacao({
        tipo: tipoBusca,
        valor: tipoBusca === 'telefone' || tipoBusca === 'prospecto' ? termoBusca.replace(/\D/g, '') : termoBusca.trim(),
        codigo_excluir: prospecto.codigo
      });

      setProspectosSugestao(response || []);
      if (!response || response.length === 0) {
        toast.info('Nenhum prospecto encontrado');
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setBuscandoManual(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      buscarManual();
    }
  };

  const abrirRdStation = (e, idRd) => {
    e.stopPropagation();
    if (idRd) {
      window.open(`https://app.rdstation.com.br/contacts/${idRd}`, '_blank');
    }
  };

  const unificar = async () => {
    try {
      setUnificandoProspecto(true);

      let response = await api.unificarProspectos({
        codigo_prospecto_principal: prospecto.codigo,
        codigo_prospecto_fonte: prospectoSelecionado.codigo,
      });

      if (response) {
        toast.info('Prospectos unificados com sucesso!');
        setProspecto(response.prospecto);
        setMostrarModalUnificar(false);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setUnificandoProspecto(false);
    }
  };

  const toggleExpand = codigo => {
    setExpandedCards(prev => ({
      ...prev,
      [codigo]: !prev[codigo],
    }));
  };

  useEffect(() => {
    if (prospecto && modoBusca === 'sugestoes') {
      buscarSugestoes();
    }
  }, [modoBusca]);

  const InfoItem = ({ icon: Icon, label, value, full = false }) => {
    if (!value) return null;
    return (
      <Col md={full ? 12 : 6}>
        <div className="info-item d-flex align-items-center mb-2">
          <Icon className="mr-2 text-muted" size={14} />
          <small>
            <strong>{label}:</strong> {value}
          </small>
        </div>
      </Col>
    );
  };

  const Titulo = ({ icon: Icon, title }) => (
    <div className="d-flex align-items-center mb-2 mt-3">
      <Icon className="mr-2 text-primary" size={16} />
      <strong className="text-primary" style={{ fontSize: '0.9rem' }}>
        {title}
      </strong>
    </div>
  );

  return (
    <Modal
      size="xl"
      show={mostrarModalUnificar}
      backdrop="static"
      onHide={() => {
        setMostrarModalUnificar(false);
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Unificar Prospecto</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Nav variant="tabs" className="mb-3">
          <Nav.Item>
            <Nav.Link
              active={modoBusca === 'sugestoes'}
              onClick={() => {
                setModoBusca('sugestoes');
                setTermoBusca('');
                buscarSugestoes();
              }}
            >
              Sugestões Automáticas
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={modoBusca === 'manual'}
              onClick={() => {
                setModoBusca('manual');
                setProspectosSugestao([]);
                setProspectoSelecionado(null);
              }}
            >
              Busca Manual
            </Nav.Link>
          </Nav.Item>
        </Nav>
        {modoBusca === 'manual' && (
          <Row className="mb-4">
            <Col md={3}>
              <Form.Control
                as="select"
                value={tipoBusca}
                onChange={(e) => setTipoBusca(e.target.value)}
                size="sm"
              >
                <option value="telefone">Telefone</option>
                <option value="email">Email</option>
                <option value="prospecto">Prospecto</option>
              </Form.Control>
            </Col>
            <Col md={7}>
              <Form.Control
                type="text"
                placeholder={tipoBusca === 'telefone' ? 'Digite o telefone...' : tipoBusca === 'email' ? 'Digite o email...' : 'Digite o código do prospecto...'}
                value={termoBusca}
                onChange={(e) => setTermoBusca(e.target.value)}
                onKeyPress={handleKeyPress}
                size="sm"
              />
            </Col>
            <Col md={2}>
              <Button
                variant="primary"
                size="sm"
                onClick={buscarManual}
                disabled={buscandoManual || !termoBusca.trim()}
                className="w-100"
              >
                {buscandoManual ? (
                  <span className="spinner-border spinner-border-sm" />
                ) : (
                  <><FaSearch /> Buscar</>
                )}
              </Button>
            </Col>
          </Row>
        )}


        {!carregandoSugestao && !buscandoManual && (
          <>
            <Row className="d-flex justify-content-center">
              {prospectosSugestao.length > 0 &&
                prospectosSugestao.map((item, id) => (
                  <Col md={12} key={id} className="mb-3">
                    <Card
                      className={`prospect-card ${prospectoSelecionado &&
                        prospectoSelecionado.codigo === item.codigo
                        ? 'prospect-card-selected'
                        : ''
                        }`}
                      onClick={() => setProspectoSelecionado(item)}
                    >
                      <Card.Body className="p-3">
                        <Row className="align-items-center">
                          <Col md="auto">
                            <FaUserCircle
                              size={40}
                              className={
                                prospectoSelecionado &&
                                  prospectoSelecionado.codigo === item.codigo
                                  ? 'text-primary'
                                  : 'text-secondary'
                              }
                            />
                          </Col>
                          <Col md={8}>
                            <div className="d-flex flex-column">
                              <h6 className="mb-1 font-weight-bold">
                                {item.nome}
                                {item.nome_social && (
                                  <small className="text-muted ml-2">
                                    ({item.nome_social})
                                  </small>
                                )}
                              </h6>
                              <small className="text-muted">
                                Código: #{item.codigo}
                              </small>
                            </div>
                          </Col>
                          <Col md="auto" className="ml-auto d-flex align-items-center">
                            {item.uuid_rd_station && (
                              <Button
                                variant="outline-info"
                                size="sm"
                                className="mr-2"
                                onClick={(e) => abrirRdStation(e, item.uuid_rd_station)}
                                title="Abrir no RD Station"
                              >
                                <FaExternalLinkAlt size={14} /> Abrir no RD Station
                              </Button>
                            )}
                          </Col>
                          <Col md="auto" className="ml-auto">
                            <Button
                              variant="link"
                              size="sm"
                              onClick={e => {
                                e.stopPropagation();
                                toggleExpand(item.codigo);
                              }}
                              className="p-0 text-secondary"
                            >
                              {expandedCards[item.codigo] ? (
                                <FaChevronUp size={18} />
                              ) : (
                                <FaChevronDown size={18} />
                              )}
                            </Button>
                          </Col>
                        </Row>

                        <Row className="mt-3">
                          <Col md={6}>
                            <div className="info-item d-flex align-items-center mb-2">
                              <FaPhone className="mr-2 text-muted" size={14} />
                              <small>
                                {format.celular(item.tel_celular) ||
                                  'Telefone não informado'}
                              </small>
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="info-item d-flex align-items-center mb-2">
                              <FaEnvelope
                                className="mr-2 text-muted"
                                size={14}
                              />
                              <small>
                                {item.email || 'Email não informado'}
                              </small>
                            </div>
                          </Col>
                        </Row>

                        {item.prospecto_empreendimento &&
                          item.prospecto_empreendimento.length > 0 && (
                            <div className="mt-2">
                              {item.prospecto_empreendimento
                                .slice(0, 3)
                                .map((vinculo, idx) => (
                                  <Badge
                                    key={idx}
                                    variant="info"
                                    className="mr-1 mb-1"
                                    style={{ fontSize: '0.7rem' }}
                                  >
                                    {(vinculo.empreendimento &&
                                      vinculo.empreendimento.descricao) ||
                                      `Emp. ${vinculo.codigo_familia}`}
                                  </Badge>
                                ))}
                              {item.prospecto_empreendimento.length > 3 && (
                                <Badge
                                  variant="secondary"
                                  style={{ fontSize: '0.7rem' }}
                                >
                                  +{item.prospecto_empreendimento.length - 3}
                                </Badge>
                              )}
                            </div>
                          )}

                        {expandedCards[item.codigo] && (
                          <div className="expanded-info mt-3 pt-3 border-top">
                            <Titulo
                              icon={FaUserCircle}
                              title="Informações Básicas"
                            />
                            <Row>
                              <InfoItem
                                icon={FaIdCard}
                                label="CPF"
                                value={item.cpf ? format.cpf(item.cpf) : null}
                              />
                              <InfoItem
                                icon={FaIdCard}
                                label="RG"
                                value={
                                  item.rg
                                    ? `${item.rg}${item.orgao_emissor_rg
                                      ? ` - ${item.orgao_emissor_rg}`
                                      : ''
                                    }`
                                    : null
                                }
                              />
                              <InfoItem
                                icon={FaVenusMars}
                                label="Sexo"
                                value={item.sexo || 'Não informado'}
                              />
                              <InfoItem
                                icon={FaCalendarAlt}
                                label="Nascimento"
                                value={
                                  item.nascimento
                                    ? format.date(item.nascimento)
                                    : null
                                }
                              />
                              <InfoItem
                                icon={FaRing}
                                label="Estado Civil"
                                value={item.estado_civil || 'Não informado'}
                              />
                              <InfoItem
                                icon={FaGlobe}
                                label="Nacionalidade"
                                value={item.descricao_nacionalidade}
                              />
                              <InfoItem
                                icon={FaBriefcase}
                                label="Profissão"
                                value={item.descricao_profissao}
                              />
                              <InfoItem
                                icon={FaCalendarAlt}
                                label="Cadastro"
                                value={format.datetime(item.data_cadastro)}
                              />
                            </Row>

                            <Titulo icon={FaPhone} title="Contatos" />
                            <Row>
                              <InfoItem
                                icon={FaPhone}
                                label="Celular"
                                value={format.celular(item.tel_celular)}
                              />
                              <InfoItem
                                icon={FaPhone}
                                label="Residencial"
                                value={format.celular(item.tel_residencial)}
                              />
                              <InfoItem
                                icon={FaPhone}
                                label="Comercial"
                                value={format.celular(item.tel_comercial)}
                              />
                              <InfoItem
                                icon={FaEnvelope}
                                label="Email"
                                value={item.email}
                              />
                            </Row>

                            {(item.endereco ||
                              item.bairro ||
                              (item.cidade && item.cidade.nome)) && (
                                <>
                                  <Titulo
                                    icon={FaMapMarkerAlt}
                                    title="Endereço"
                                  />
                                  <Row>
                                    {item.endereco && (
                                      <InfoItem
                                        icon={FaHome}
                                        label="Logradouro"
                                        value={`${item.endereco}${item.numero ? `, ${item.numero}` : ''
                                          }${item.complemento
                                            ? ` - ${item.complemento}`
                                            : ''
                                          }`}
                                        fullWidth
                                      />
                                    )}
                                    <InfoItem
                                      icon={FaMapMarkerAlt}
                                      label="Bairro"
                                      value={item.bairro}
                                    />
                                    <InfoItem
                                      icon={FaMapMarkerAlt}
                                      label="Cidade/UF"
                                      value={
                                        item.cidade && item.cidade.nome
                                          ? `${item.cidade.nome}${item.estado && item.estado.sigla
                                            ? `/${item.estado.sigla}`
                                            : ''
                                          }`
                                          : null
                                      }
                                    />
                                    <InfoItem
                                      icon={FaHashtag}
                                      label="CEP"
                                      value={
                                        item.cep ? format.cep(item.cep) : null
                                      }
                                    />
                                  </Row>
                                </>
                              )}

                            {item.prospecto_empreendimento &&
                              item.prospecto_empreendimento.length > 0 && (
                                <>
                                  <Titulo
                                    icon={FaBuilding}
                                    title="Vínculos com Empreendimentos"
                                  />
                                  {item.prospecto_empreendimento.map(
                                    (vinculo, idx) => {
                                      return (
                                        <Card
                                          key={idx}
                                          className="mb-2 bg-light"
                                        >
                                          <Card.Body className="p-2">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                              <div>
                                                <strong
                                                  style={{
                                                    fontSize: '0.85rem',
                                                  }}
                                                >
                                                  {(vinculo.empreendimento &&
                                                    vinculo.empreendimento
                                                      .descricao) ||
                                                    `Empreendimento ${vinculo.codigo_familia}`}
                                                </strong>
                                                {vinculo.empreendimento &&
                                                  vinculo.empreendimento
                                                    .descricao_grupo_empresa && (
                                                    <small className="d-block text-muted">
                                                      {
                                                        vinculo.empreendimento
                                                          .descricao_grupo_empresa
                                                      }
                                                    </small>
                                                  )}
                                              </div>
                                            </div>
                                            <Row>
                                              <Col md={4}>
                                                <small className="d-flex align-items-center">
                                                  <FaUserTie
                                                    className="mr-1 text-muted"
                                                    size={12}
                                                  />
                                                  <strong>Corretor: </strong>{' '}
                                                  {(vinculo.corretor &&
                                                    vinculo.corretor.nome) ||
                                                    'Não atribuído'}
                                                </small>
                                              </Col>
                                              <Col md={4}>
                                                <small className="d-flex align-items-center">
                                                  <FaUsers
                                                    className="mr-1 text-muted"
                                                    size={12}
                                                  />
                                                  <strong>Gerente: </strong>{' '}
                                                  {(vinculo.gerente &&
                                                    vinculo.gerente.nome) ||
                                                    'Não atribuído'}
                                                </small>
                                              </Col>
                                              <Col md={4}>
                                                <small className="d-flex align-items-center">
                                                  <FaBuilding
                                                    className="mr-1 text-muted"
                                                    size={12}
                                                  />
                                                  <strong>Imobiliária:</strong>{' '}
                                                  {(vinculo.imobiliaria &&
                                                    vinculo.imobiliaria.nome) ||
                                                    'SGI'}
                                                </small>
                                              </Col>
                                            </Row>
                                            <Row className="mt-1">
                                              <Col md={6}>
                                                <small className="d-flex align-items-center">
                                                  <FaCalendarAlt
                                                    className="mr-1 text-muted"
                                                    size={12}
                                                  />
                                                  <strong>Vínculo:</strong>{' '}
                                                  {format.datetime(
                                                    vinculo.data_vinculo
                                                  )}
                                                </small>
                                              </Col>
                                            </Row>
                                          </Card.Body>
                                        </Card>
                                      );
                                    }
                                  )}
                                </>
                              )}

                            {item.descricao_origem_prospecto && (
                              <>
                                <Titulo icon={FaGlobe} title="Origem" />
                                <Row>
                                  <InfoItem
                                    icon={FaGlobe}
                                    label="Origem do Cadastro"
                                    value={item.descricao_origem_prospecto}
                                    fullWidth
                                  />
                                  {item.midia_origem && (
                                    <InfoItem
                                      icon={FaGlobe}
                                      label="Mídia"
                                      value={item.midia_origem}
                                    />
                                  )}
                                </Row>
                              </>
                            )}
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              {prospectosSugestao.length === 0 && (
                <div className="text-center py-5">
                  <FaUserCircle size={60} className="text-muted mb-3" />
                  <p className="text-muted">Nenhuma sugestão encontrada.</p>
                </div>
              )}
            </Row>

            {prospectosSugestao.length > 0 && (
              <div className="d-flex justify-content-end mt-4">
                <Button
                  variant="primary"
                  size="sm"
                  className="d-inline-flex align-items-center px-4"
                  disabled={!prospectoSelecionado || unificandoProspecto}
                  onClick={unificar}
                >
                  {unificandoProspecto ? (
                    <>
                      <span className="spinner-border spinner-border-sm mr-2" />
                      <span>Unificando...</span>
                    </>
                  ) : (
                    <>
                      <FaSyncAlt className="mr-2" />
                      <span>Unificar Prospectos</span>
                    </>
                  )}
                </Button>
              </div>
            )}
          </>
        )}
        {(carregandoSugestao || buscandoManual) && (
          <div className="text-center py-5">
            <Loading label={modoBusca === 'sugestoes' ? 'Carregando sugestões...' : 'Buscando...'} />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          size="sm"
          className="d-inline-flex align-items-center"
          onClick={() => setMostrarModalUnificar(false)}
          disabled={unificandoProspecto}
        >
          <FaWindowClose className="mr-2" />
          <span>Fechar</span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalUnificar;
